export enum StationAppConfigFormEventKey {
  SavePreOrder = 'save-pre-order',
  SaveScanNPay = 'save-scan-n-pay',
  SaveJustWalkOut = 'save-just-walk-out',
  SavePaymentExclusions = 'save-payment-exclusions',
  PaymentSettingsRemovedStation = 'payment-settings-removed-station',
}

export enum DropoffSidebarEventKey {
  SubmitForm = 'submitForm',
  EditTimeslot = 'editTimeslot',
  DeleteTimeslot = 'deleteTimeslot',
}
